export default Object.freeze({
    anima: 1,
    ofx: 2,
});
